import React from 'react';

interface TitleDividerProps {
  title: string;
}

export const TitleDivider: React.FC<TitleDividerProps> = ({ title }) => {
  return (
    <div className="wc-flex wc-items-center wc-justify-center wc-my-3 wc-px-4">
      <div className="wc-flex-1 wc-h-px" style={{ backgroundColor: 'var(--wc-text-color)', opacity: 0.12 }} />
      <span
        className="wc-px-3 wc-text-xs wc-font-medium wc-whitespace-nowrap"
        style={{ color: 'var(--wc-text-color)', opacity: 0.4 }}
      >
        {title}
      </span>
      <div className="wc-flex-1 wc-h-px" style={{ backgroundColor: 'var(--wc-text-color)', opacity: 0.12 }} />
    </div>
  );
};
